import React, { useState, useEffect } from 'react';
import CustomInput from '../../../Utility/Components/CustomInput';
import Utility from '../../../Utility/Utility';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { setToken, logOutApp } from '../Actions/LoginAction';
import { connect } from 'react-redux';
import * as LoginController from '../Controller/LoginController'
import '../Assets/css/logindoc.scss';


const RenewPassword = (props) => {
    const [state, setState] = useState({
        username: "",
        passwordResetCode: "",
        password: "",
        retypePassword: "",
        usernameError: "",
        passwordResetCodeError: "",
        passwordError: "",
        retypePasswordError: "",
        hideShowChangePasswordPanel: false
    })
    const { t, i18n } = useTranslation();

    const { loaderStateTrue, loaderStateFalse, history, logOutApp } = props

    //handle change input field
    const handleChange = (e) => {
        if (e.target.name == "username") {
            let emailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value);
            if (emailValidate) {
                setState(prev => ({
                    ...prev,
                    usernameError: ""
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    usernameError: `${t("emailError")}`
                }))
            }
        }

        //change password
        if (e.target.name == "password") {
            if (e.target.value == "") {
                setState(prev => ({
                    ...prev,
                    passwordError: `${t("passwordError")}`
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    passwordError: ""
                }))
            }
        }
        if (e.target.name == "retypePassword") {
            if (e.target.value == "") {
                setState(prev => ({
                    ...prev,
                    retypePasswordError: `${t("retypepasswordError")}`
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    retypePasswordError: ""
                }))
            }
        }
        if (e.target.name == "passwordResetCode") {
            if (e.target.value == "") {
                setState(prev => ({
                    ...prev,
                    passwordResetCodeError: `${t("enterverificationCode")}`
                }))
            } else {
                setState(prev => ({
                    ...prev,
                    passwordResetCodeError: ""
                }))
            }
        }
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const forgotPassword = async () => {
        const { username } = state;
        if (validationForEmail()) {
            try {
                let data = {}
                data['username'] = username;
                loaderStateTrue();
                LoginController.forgotPassword(data).then((response) => {
                    if (response.success) {
                        Utility.toastNotifications(response.message, "Success", "success");
                        setState(prev => ({
                            ...prev,
                            hideShowChangePasswordPanel: true
                        }))
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                    loaderStateFalse();
                }).catch((error) => {
                    loaderStateFalse();
                });

            } catch (error) {
                if (error.code == "UserNotFoundException") {
                    Utility.toastNotifications("User not found", "Error", "error")
                } else {
                    Utility.toastNotifications(error.message, "Error", "error")
                }
            }
        }
    }

    const requestForNewPassword = async () => {
        const { username, passwordResetCode, password } = state;
        if (validationForPasswordChange()) {
            try {
                let data = {}
                data['username'] = username.trim();
                data['password'] = password.trim();
                data['confirmation_code'] = passwordResetCode;
                loaderStateTrue();
                LoginController.changePassword(data).then((response) => {
                    loaderStateFalse();
                    if (response.success) {
                        Utility.toastNotifications(response.message, "Success", "success");
                        history.push("/");
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error");
                    }

                }).catch((error) => {
                    loaderStateFalse();
                });

            } catch (error) {
                if (error.code == "UserNotFoundException") {
                    Utility.toastNotifications("User not found", "Error", "error")
                } else {
                    Utility.toastNotifications(error.message, "Error", "error")
                }
            }
        }
    }

    const validationForEmail = () => {
        let valid = true;
        const { username, password } = state;
        let emailValidate = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(username.trim());
        if (emailValidate) {
            setState(prev => ({
                ...prev,
                usernameError: ""
            }))
        } else {
            valid = false;
            setState(prev => ({
                ...prev,
                usernameError: `${t('emailError')}`
            }))
        }
        return valid;
    }
    const validationForPasswordChange = () => {
        let valid = true;
        const { passwordResetCode, password, retypePassword } = state;
        if (password.trim() == "") {
            valid = false;
            setState(prev => ({
                ...prev,
                passwordError: `${t('passwordError')}`
            }))
        } else {
            setState(prev => ({
                ...prev,
                passwordError: ""
            }))
        }
        if (retypePassword.trim() == "") {
            valid = false;
            setState(prev => ({
                ...prev,
                retypePasswordError: `${t('retypepasswordError')}`
            }))
        } else {
            setState(prev => ({
                ...prev,
                retypePasswordError: ""
            }))
        }
        if ((password.trim() != "" && retypePassword.trim() != "") && password.trim() != retypePassword.trim()) {
            valid = false;
            setState(prev => ({
                ...prev,
                retypePasswordError: `${t('passwordnotmatch')}`,
                passwordError: `${t('passwordnotmatch')}`
            }))
        }
        if (passwordResetCode == "") {
            valid = false;
            setState(prev => ({
                ...prev,
                passwordResetCodeError: `${t('enterverificationCode')}`
            }))
        } else {
            setState(prev => ({
                ...prev,
                passwordResetCodeError: ""
            }))
        }
        return valid;
    }
    const { hideShowChangePasswordPanel } = state;

    const back_to_login = () => {
        props.history.push("/")
    }

    return (
        <div className="appContainer">
            <div className="loginBackground ForgotPage renewpassword">
                <div className="appContainerInner appContainerInnerForgot">
                    <div className="left_section login_box_inner white_background forgotpass">
                        <div className="logo-box-inner">
                            <div className="titleposition">
                                <img src={require('../../Utility/Public/images/logo.png')} className="logoInner" />
                                <h3 className="titletwo">Personalized Message Space</h3>
                            </div>
                        </div>
                        <div className="itemsContainer login_left_inner">
                            <div className="forgotFormDiv">
                                <div>
                                    <CustomInput
                                        parentClassName="loginFormInnerDiv input_field_small_size"
                                        name="password"
                                        type="password"
                                        placeholder={t('NewpasswordPlaceHolder')}
                                    />
                                    <CustomInput
                                        parentClassName="loginFormInnerDiv input_field_small_size"
                                        name="retypePassword"
                                        type="password"
                                        placeholder={t('RetypenewpasswordPlaceHolder')}
                                    />

                                    <div className="forgor_btnBoxes">
                                        <div className="forgor_btn_inner_div bottom15">
                                            <button className="login-btn btn btn-primary" onClick={requestForNewPassword}>{t('updatePasswordButton')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, logOutApp })(RenewPassword);